export function copyObject(obj) {
  if (typeof obj === 'object') {
    return JSON.parse(JSON.stringify(obj))
  } else return obj
}

export function copyObjectBy(srcKeyObj, fromObj) {
  if (!fromObj) return null

  const _src = srcKeyObj ?? fromObj

  if (typeof fromObj === 'object') {
    if (Array.isArray(_src)) {
      // если массив берём как образец первый элемент
      const data = []
      for (let key in fromObj) {
        const value = fromObj[key]

        if (typeof value === 'object') {
          data[key] = copyObjectBy(_src[0], value)
        } else data[key] = value
      }
      return data
    } else {
      // если объект
      const data = {}
      for (let key in _src) {
        const value = fromObj[key]

        if (typeof value === 'object') {
          data[key] = copyObjectBy(_src[key], value)
        } else data[key] = value
      }
      return data
    }
  } else return null
}

/** Сравниваем два объекта в лоб через stringify */
export function sameObject(a, b) {
  if (a === b) return true

  if (a instanceof Date && b instanceof Date && a.getTime() !== b.getTime()) {
    // If the values are Date, compare them as timestamps
    return false
  }

  if (a !== Object(a) || b !== Object(b)) {
    // If the values aren't objects, they were already checked for equality
    return false
  }

  const props = Object.keys(a)

  if (props.length !== Object.keys(b).length) {
    // Different number of props, don't bother to check
    return false
  }

  return props.every(p => sameObject(a[p], b[p]))
}

/** If the path is a string, convert it to an array
 * @param  {String|Array} path The path
 * @return {Array}             The path array
 */
export function stringToPath(path) {
  if (!path) return []
  // If the path isn't a string, return it
  if (typeof path !== 'string') return path
  const output = []
  // Split to an array with dot notation
  path.split('.').forEach(item => {
    // Split to an array with bracket notation
    item.split(/\[([^}]+)\]/g).forEach(key => {
      // Push to the new array
      if (key?.length) output.push(key)
    })
  })
  return output
}

/** Get an object value from a specific path
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Object}       obj  The object
 * @param  {String|Array} path The path
 * @param  {*}            def  A default value to return [optional]
 * @return {*}                 The value
 */
export function objectByPath(obj, path, def) {
  if (!path || !obj) return obj
  // Get the path as an array
  path = stringToPath(path)
  // Cache the current object
  var current = obj
  // For each item in the path, dig into the object
  for (var i = 0; i < path.length; i++) {
    // If the item isn't found, return the default (or null)
    if (!current[path[i]]) return def
    // Otherwise, update the current  value
    current = current[path[i]]
  }
  return current
}
/** нумеруем элементы (сквозная или по группе)  */
export function setIndexBy(arr, groupBy = '', indexName = 'index') {
  if (!Array.isArray(arr)) return arr
  if (groupBy) {
    const gb = new Map()
    return arr.map(el => {
      const i = (gb.get(el[groupBy]) ?? 0) + 1
      gb.set(el[groupBy], i)
      return { ...el, [indexName]: i }
    })
  } else {
    return arr.map((el, i) => ({ ...el, [indexName]: i + 1 }))
  }
}

export const ignoreOrderCompare = (a, b) => {
  if (a.length !== b.length) return false
  const elements = new Set([...a, ...b])
  for (const x of elements) {
    const count1 = a.filter(e => e === x).length
    const count2 = b.filter(e => e === x).length
    if (count1 !== count2) return false
  }
  return true
}

/**
 * Возвращает **obj** как есть или вызывает, если функция **obj()**
 * @param {Object | Function} obj
 * @returns {Object}
 */
export function getObject(obj) {
  return { obj: typeof obj === 'function' ? obj() : obj }
}

/**
 * Возвращает true если это объект и он пуст**
 * @param {Object | Function} obj
 * @returns Boolean
 */
export function isEmptyObject(obj) {
  let res =
    obj &&
    Object.keys(obj).length === 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  return res
}

export function isObjectValuesEmpty(objectName) {
  let res = true
  for (let prop in objectName) {
    // eslint-disable-next-line no-prototype-builtins
    if (objectName.hasOwnProperty(prop)) {
      let x = objectName[prop]
      if (!x) continue
      if (Array.isArray(x) && !x.length) {
        continue
      }
      if (typeof x === 'object' && isEmptyObject(x)) {
        continue
      }
      if (x) {
        res = false
        break
      }
    }
  }

  return res
}
